import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as FullStory from '@fullstory/browser';

import config from '../config';
import { getProfileKey } from '../redux/nodes/authentication/selectors';

/**
 * useFullstory - a hook for interacting with @fullstory/browser
 *
 * Executes events on startup to setUserVars, identify, and initialize fullstory.
 */
export default function useFullstory() {
  const cfHeaders = useSelector(state => state.application.cloudflareHeaders);
  const profileKey = useSelector(getProfileKey);
  const [initialized, setInitialized] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const fsOrgId = config.fullStoryOrgId;

  useEffect(() => {
    /* eslint-disable camelcase */
    const {
      'cf-bot-verified': botVerified,
      'cf-bot-score': botScore,
      'cf-ipcountry': geoCountry_str,
      'cf-ipregion': geoRegion_str,
      'cf-ipcity': geoCity_str,
      'cf-ippostalcode': geoPostcode_str,
    } = cfHeaders;
    /* eslint-enable camelcase */

    // Get these values from CF to track whether we think users are bots
    const isBot = botVerified === 'true' || botScore < 30;

    if (isBot || !fsOrgId || initialized) {
      return;
    }

    // Init the project
    FullStory.init({ orgId: fsOrgId });
    setInitialized(true);

    // Items available on pageload
    FullStory.setUserVars({
      // Geo information from CF
      geoCountry_str,
      geoRegion_str,
      geoCity_str,
      geoPostcode_str,
    });
  }, []);

  useEffect(() => {
    if (!initialized) {
      return;
    }

    if (profileKey) {
      FullStory.identify(profileKey);
      setLoggedIn(true);
    } else if (loggedIn && !profileKey) {
      FullStory.anonymize();
    }
  }, [profileKey, initialized]);
}
